import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.shop-category-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: true,
          gap: '20px',
          perPage: 5,
          paginationKeyboard: true,
          drag: true,
          pagination: false,
          breakpoints: {
            768: {
              perPage: 1,
              arrows: false,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
          };
        } );
        slider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'shop-category-slider', COMPONENT );
} )( app );
